import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { withSitecoreContext, Image } from "@sitecore-jss/sitecore-jss-react";
import MessageIcon from "@clarion/foundation/dist/Theming/icons/MessageIcon";
import { openChatbot } from "@clarion/foundation/dist/Utils/genericUtils";
import { START_CHAT_EVENT } from "@clarion/foundation/dist/Settings/constants";
import { getColourVariant, getSizeVariant, getPositionVariant } from "../Utils/chatbotUtils";
import "./index.css";
const BoostChatbot = ({
  sitecoreContext,
  t,
  ...props
}) => {
  const fields = sitecoreContext.route.fields;
  const chatColourVariant = fields.Colour ? getColourVariant(fields.Colour.name) : getColourVariant(null);
  const chatSizeVariant = fields.Size ? getSizeVariant(fields.Size.name) : getSizeVariant(null);
  const chatPositionVariant = fields.Position ? getPositionVariant(fields.Position.name) : getPositionVariant(null);
  const chatIcon = fields.Icon;
  const messagingDelay = props.fields.MessagingDelay ? parseInt(props.fields.MessagingDelay.name) * 1000 : 0;
  const chatTitle = props.fields.Title.value;
  const chatDescription = props.fields.Description.value;
  const closeLabel = props.fields.Close.value;
  const configuredScriptUrl = props.fields?.BoostScriptUrl;
  const configuredScriptName = props.fields?.BoostScriptName;
  const openChatLabel = t("Accessibility_OpenChatLabel");
  const hasMessaging = chatTitle || chatDescription;
  const [showMessaging, setShowMessaging] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const cookie = useSelector(state => state.cookie);
  const showChatbot = !isDismissed && cookie.isThirdPartyEnabled;
  const launchChatbot = () => {
    if (window.boost) {
      window.boost.chatPanel.show();
    }
  };
  const loadChat = () => {
    let chatbotScript = document.getElementById("chatbot-script");
    if (!chatbotScript) {
      chatbotScript = document.createElement("script");
      chatbotScript.src = configuredScriptUrl;
      chatbotScript.async = true;
      chatbotScript.id = "chatbot-script";
      chatbotScript.onload = () => {
        window.boost = window.boostInit(configuredScriptName);
        document.getElementById("chat-container")?.addEventListener(START_CHAT_EVENT, launchChatbot);
      };
      document.body.appendChild(chatbotScript);
    }
  };
  const dismissChatbot = () => {
    setIsDismissed(true);
  };
  useEffect(() => {
    let timeout;
    if (showChatbot) {
      // Only load chat if 3rd party cookies toggled on since 3rd party code can set unwanted cookies
      loadChat();
      timeout = setTimeout(() => {
        setShowMessaging(true);
      }, messagingDelay);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [cookie.isThirdPartyEnabled]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showChatbot && /*#__PURE__*/React.createElement("div", {
    className: `chatbot ${chatPositionVariant} ${chatColourVariant} ${chatSizeVariant} ${!hasMessaging || !showMessaging ? "chatbot--icon-only" : ""} ${hasMessaging ? "chatbot--mobile-no-middle" : ""}`
  }, hasMessaging && showMessaging ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    id: "chatbot-btn",
    className: "chatbot__open-btn",
    "aria-label": openChatLabel,
    type: "button",
    onClick: openChatbot
  }, /*#__PURE__*/React.createElement("div", {
    className: "chatbot__messaging"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "chatbot__heading"
  }, chatTitle), /*#__PURE__*/React.createElement("p", {
    className: "chatbot__sub-heading copy-small"
  }, chatDescription)), /*#__PURE__*/React.createElement("div", {
    className: "chatbot__icon-container"
  }, chatIcon.value?.src ? /*#__PURE__*/React.createElement(Image, {
    className: "chatbot__icon",
    field: chatIcon
  }) : /*#__PURE__*/React.createElement(MessageIcon, {
    className: "chatbot__icon"
  }))), /*#__PURE__*/React.createElement("button", {
    className: "chatbot__close-btn",
    type: "button",
    onClick: dismissChatbot
  }, /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, closeLabel))) : /*#__PURE__*/React.createElement("button", {
    id: "chatbot-btn",
    className: "chatbot__icon-container",
    "aria-label": openChatLabel,
    type: "button",
    onClick: openChatbot
  }, chatIcon.value?.src ? /*#__PURE__*/React.createElement(Image, {
    className: "chatbot__icon",
    field: chatIcon
  }) : /*#__PURE__*/React.createElement(MessageIcon, {
    className: "chatbot__icon"
  }))));
};
const BoostChatbotWithTranslation = withTranslation()(BoostChatbot);
export default withSitecoreContext()(BoostChatbotWithTranslation);